import React, { useState } from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const DestinationsPage = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const destinations = [
    { id: "uk", flag: "🇬🇧", name: "United Kingdom", unis: "140+ Universities", fee: "£14,000 - £35,000 / yr", work: "2 Years Post-Study Work Permit", img: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=600&q=80" },
    { id: "usa", flag: "🇺🇸", name: "United States", unis: "200+ Universities", fee: "$20,000 - £55,000 / yr", work: "3 Years STEM OPT Extension", img: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=600&q=80" },
    { id: "canada", flag: "🇨🇦", name: "Canada", unis: "90+ Universities", fee: "CAD 18,000 - 45,000 / yr", work: "3 Years Post-Graduation Work Permit", img: "https://images.unsplash.com/photo-1503614472-8c93d56e92ce?auto=format&fit=crop&w=600&q=80" },
    { id: "australia", flag: "🇦🇺", name: "Australia", unis: "45+ Universities", fee: "AUD 22,000 - 48,000 / yr", work: "2 to 4 Years Post-Study Work Visa", img: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?auto=format&fit=crop&w=600&q=80" },
    { id: "germany", flag: "🇩🇪", name: "Germany", unis: "60+ Universities", fee: "€0 Tuition Fee (Public Unis)", work: "18 Months Post-Study Work Visa", img: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=600&q=80" },
    { id: "ireland", flag: "🇮🇪", name: "Ireland", unis: "30+ Universities", fee: "€12,000 - 25,000 / yr", work: "2 Years Third-Level Graduate Scheme", img: "https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?auto=format&fit=crop&w=600&q=80" },
    { id: "newzealand", flag: "🇳🇿", name: "New Zealand", unis: "25+ Universities", fee: "NZD 22,000 - 38,000 / yr", work: "3 Years Post-Study Work Rights", img: "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?auto=format&fit=crop&w=600&q=80" },
    { id: "france", flag: "🇫🇷", name: "France", unis: "40+ Universities", fee: "€3,000 - 18,000 / yr", work: "2 Years Post-Study Job Search Visa", img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=600&q=80" },
  ];

  const filtered = destinations.filter(d => d.name.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Header Banner */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Study Destinations</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Explore the World. Find Your Future.</h1>
          <p className="consultancy-lead-text mx-auto" style={{ maxWidth: "650px" }}>
            Compare top study destinations based on university rankings, tuition fees, post-study work rights, and visa policies.
          </p>

          <div className="mt-4 mx-auto" style={{ maxWidth: "450px" }}>
            <input
              type="text"
              className="form-control consultancy-form-control text-center"
              placeholder="Search destination country..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </section>

      {/* Destination Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {filtered.map((d) => (
            <div key={d.id} className="col-lg-4 col-md-6">
              <div className="consultancy-glass-card h-100 overflow-hidden d-flex flex-column justify-content-between">
                <div>
                  <div className="position-relative" style={{ height: "200px" }}>
                    <img src={d.img} alt={d.name} className="w-100 h-100" style={{ objectFit: "cover" }} />
                    <span className="position-absolute top-0 end-0 m-3 fs-2">{d.flag}</span>
                  </div>
                  <div className="p-4">
                    <h4 className="font-weight-bold consultancy-gold-title mb-1">{d.name}</h4>
                    <div className="consultancy-gold-text small font-weight-bold mb-3">{d.unis}</div>

                    <div className="small text-muted mb-2">
                      <i className="fas fa-coins text-warning mr-2"></i> Tuition: <strong className="text-white">{d.fee}</strong>
                    </div>
                    <div className="small text-muted mb-3">
                      <i className="fas fa-briefcase text-warning mr-2"></i> Work Rights: <strong className="text-white">{d.work}</strong>
                    </div>
                  </div>
                </div>

                <div className="p-4 pt-0">
                  <Link to={`/consultancy/destinations/${d.id}`} className="consultancy-btn-gold w-100 text-center">
                    Explore Study in {d.name} <i className="fas fa-arrow-right ml-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default DestinationsPage;
